import React from 'react';
import PropTypes from 'prop-types';
import MaterialTextField from 'shared/components/connectedTextField/c/materialTextField/MaterialTextField';
import SelectField from 'material-ui/SelectField';
import MenuItem from 'material-ui/MenuItem';
import { disabledButtonTextGray, textColorGray } from 'theme/mainColors';

const inputStyle = { width: '100%', marginLeft: 24 };
const textStyle = { fontSize: 15, color: textColorGray };

class CostObjLocation extends React.Component {
  constructor(props) {
    super(props);
    const {
      addressLine1,
      addressLine2,
      city,
      costObjectId,
      locationId,
      locationType,
      state,
      zipCode
    } = props.location;
    this.state = {
      location: {
        addressLine1,
        addressLine2,
        city,
        costObjectId,
        locationId,
        locationType,
        state,
        zipCode
      }
    };
  }

  handleInputChange = (ev, value) => {
    const target = ev.target;
    this.setState(
      oldState => ({
        location: { ...oldState.location, [target.name]: value }
      }),
      () => {
        this.props.onLocationChange(this.state.location);
      }
    );
  };

  handleSelectChange = (ev, index, value) => {
    this.setState(
      oldState => ({
        location: { ...oldState.location, locationType: value }
      }),
      () => {
        this.props.onLocationChange(this.state.location);
      }
    );
  };

  handleAddLocation = () => this.props.onAddLocation();

  handleRemoveLocation = () => this.props.onRemoveLocation();

  render() {
    const { locationTypes, fetchingLocationTypes } = this.props;
    const { location } = this.state;
    return (
      <div>
        <SelectField
          name={ 'locationTypeKey' }
          hintText="Set Location Types"
          className="cost-obj-location-types"
          maxHeight={ 300 }
          iconStyle={ { fill: disabledButtonTextGray } }
          hintStyle={ { ...textStyle, color: disabledButtonTextGray } }
          labelStyle={ textStyle }
          underlineStyle={ { borderColor: disabledButtonTextGray } }
          value={ location.locationType }
          onChange={ this.handleSelectChange }
          disabled={ fetchingLocationTypes }
        >
          <MenuItem
            value={ '' }
            primaryText="Set Location Types"
            style={ { color: '#bcbcbc' } }
          />
          {locationTypes.map((locationType, index) => (
            <MenuItem
              key={ index }
              value={ locationType.value }
              primaryText={ locationType.name }
            />
          ))}
        </SelectField>
        <div className="cost-obj-location-container">
          <div className="cost-obj-location-container__inputs-column">
            <div className="cost-obj-location-container__inputs-column__input-container">
              <MaterialTextField
                name={ 'addressLine1' }
                label="Address Line 1"
                value={ location.addressLine1 }
                onChange={ this.handleInputChange }
                fullWidth={ true }
                required
              />
            </div>
            <div className="cost-obj-location-container__inputs-column__input-container">
              <MaterialTextField
                name={ 'city' }
                label="City"
                value={ location.city }
                onChange={ this.handleInputChange }
                fullWidth={ true }
                required
              />
            </div>
            <div className="cost-obj-location-container__inputs-column__input-container">
              <MaterialTextField
                name={ 'zipCode' }
                label="ZIP + 4"
                value= { location.zipCode }
                onChange={ this.handleInputChange }
                fullWidth={ true }
                required
              />
            </div>
          </div>
          <div className="cost-obj-location-container__inputs-column">
            <div className="cost-obj-location-container__inputs-column__input-container">
              <MaterialTextField
                name={ 'addressLine2' }
                label="Address Line 2"
                value={ location.addressLine2 }
                onChange={ this.handleInputChange }
                style={ inputStyle }
                fullWidth={ true }
              />
            </div>
            <div className="cost-obj-location-container__inputs-column__input-container">
              <MaterialTextField
                name={ 'state' }
                label="State"
                value={ location.state }
                onChange={ this.handleInputChange }
                style={ inputStyle }
                fullWidth={ true }
                required
              />
            </div>
          </div>
        </div>
      </div>
    );
  }
}

CostObjLocation.propTypes = {
  locationTypes: PropTypes.array.isRequired,
  onLocationChange: PropTypes.func.isRequired,
  fetchingLocationTypes: PropTypes.bool.isRequired,
  onAddLocation: PropTypes.func.isRequired,
  onRemoveLocation: PropTypes.func.isRequired,
  isRemoveIconDisabled: PropTypes.bool.isRequired,
  showAddIcon: PropTypes.bool.isRequired,
  location: PropTypes.object.isRequired
};

export default CostObjLocation;



// WEBPACK FOOTER //
// ./src/components/manageCostObjs/comp/costObjEditor/c/CostObjLocation.js